import * as React from 'react';
import { IBasePageProps } from '../../configuration/IConfiguration';
import * as DataActionCreators from "../../../../actions/data.actions";
import * as DashboardActionCreators from "../../../../actions/dashboard.actions";
import * as AdminActionCreators from "../../../../actions/admin.actions";
import * as UserActionCreators from "../../../../actions/user.actions";
import * as DTOS from "../../../../FeralScan.dtos";
import { ReferenceDataState } from '../../../../reducers/referenceData.reducer';
import PaginatedTable from '../../../Data/PaginatedTable/PaginatedTable';
import ModalMessage from '../../../Common/Modal';
import { Link, Redirect } from 'react-router-dom';
import PlotAdminEdit from '../../../Data/Plot/PlotAdminEdit';
import ContentTabs from '../../../Content/ContentTabs';
import PlotEventAdminSearch from '../../../Data/PlotEvent/PlotEventAdminSearch';
import { connect } from 'react-redux';
import { IAppState } from '../../../../app';
import { bindActionCreators } from 'redux';
import moment = require('moment');

type PageAdminPlotEditProps = {
}

type PageAdminPlotEditActions = {
}

type PageAdminPlotEditRouteParams = {
    plotId: string;
}

type PageAdminPlotEditQueryParams = {
}

type PageAdminPlotEditPropsMapped = {
    plot: DTOS.Plot;
    plotLoading: boolean;
    plotEventsLoading: boolean;
    plotPhotoUploading: boolean,
    plotSaving: boolean;
    referenceData: ReferenceDataState;
    userRoles: DTOS.UserRole[];
    userRolesLoading: boolean;
    userRoleUnassignPending: boolean;
}

type PageAdminPlotEditActionsMapped = {
    getPlotEvents: typeof DataActionCreators.getPlotEventsRequest;
    getSinglePlot: typeof DataActionCreators.getSinglePlotRequest;
    searchUserRoles: typeof AdminActionCreators.searchUserRolesRequest;
    updatePlot: typeof DashboardActionCreators.updatePlotRequest;
    uploadPlotPhotos: typeof DashboardActionCreators.uploadPlotPhotosRequest;
    unassignUserRole: typeof UserActionCreators.unassignUserRoleRequest;
}

type PageAdminPlotEditAllPropsInherited = PageAdminPlotEditProps & PageAdminPlotEditActions;
type PageAdminPlotEditAllPropsMapped = PageAdminPlotEditPropsMapped & PageAdminPlotEditActionsMapped;

type PageAdminPlotEditAllProps = IBasePageProps<PageAdminPlotEditRouteParams, PageAdminPlotEditQueryParams> & Partial<PageAdminPlotEditAllPropsMapped> & PageAdminPlotEditAllPropsInherited;

interface IPageAdminPlotEditState {
    deleteUserRole: DTOS.UserRole;
    showDeleteUserRoleModal: boolean;
    plotReadyToSave: any;

    plotEventSearchStartDate: any;
    plotEventSearchEndDate: any;
}

class PageAdminPlotEdit extends React.Component<PageAdminPlotEditAllProps, IPageAdminPlotEditState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showDeleteUserRoleModal: false,
            plotReadyToSave: undefined,
            deleteUserRole: undefined,
            plotEventSearchStartDate: undefined,
            plotEventSearchEndDate: moment(),
        }

        this.onDeleteUserRoleHideModal = this.onDeleteUserRoleHideModal.bind(this);
        this.onDeleteUserRoleItem = this.onDeleteUserRoleItem.bind(this);
    }

    onDeleteUserRoleHideModal() {
        this.setState({
            showDeleteUserRoleModal: false,
            deleteUserRole: undefined
        });
    }

    onDeleteUserRole(ur: DTOS.UserRole) {
        this.setState({
            showDeleteUserRoleModal: true,
            deleteUserRole: ur
        });
    }

    onDeleteUserRoleItem() {
        if (this.state.deleteUserRole)
            this.props.unassignUserRole(this.state.deleteUserRole.id);

        this.setState({
            showDeleteUserRoleModal: false,
            deleteUserRole: undefined
        });
    }

    onPlotEventSearchStartDateChange(date) {
        this.setState({
            plotEventSearchStartDate: moment(date
                ? date
                : this.state.plotEventSearchStartDate).endOf('day')
        })
    }

    onPlotEventSearchEndDateChange(date) {
        this.setState({
            plotEventSearchEndDate: moment(date
                ? date
                : this.state.plotEventSearchEndDate).endOf('day')
        })
    }

    componentDidMount() {
        if (this.props.routeParams.plotId) {
            const plotId = Number(this.props.routeParams.plotId)
            this.props.getSinglePlot(plotId)

            this.props.searchUserRoles(undefined, plotId);

            this.props.getPlotEvents(plotId, undefined, 500, this.state.plotEventSearchStartDate, this.state.plotEventSearchEndDate)
        }
    }

    componentDidUpdate(prevProps: PageAdminPlotEditAllProps, prevState: IPageAdminPlotEditState) {
        const { plotEventsLoading, } = this.props;

        if ((prevProps.plotSaving && !this.props.plotSaving
            || prevProps.plotPhotoUploading && !this.props.plotPhotoUploading)) {
            const plotId = Number(this.props.routeParams.plotId)
            this.props.getSinglePlot(plotId)
            this.props.searchUserRoles(undefined, plotId);
        }

        if (this.props.plot
            && !this.props.plotLoading
            && prevProps.userRoleUnassignPending
            && !this.props.userRoleUnassignPending) {
            this.props.searchUserRoles(undefined, this.props.plot.id);
        }

        if (!plotEventsLoading
            && (prevState.plotEventSearchStartDate != this.state.plotEventSearchStartDate
                || prevState.plotEventSearchEndDate != this.state.plotEventSearchEndDate)) {
            this.props.getPlotEvents(this.props.plot.id, undefined, 500, this.state.plotEventSearchStartDate, this.state.plotEventSearchEndDate)
        }
    }

    render() {

        const { defaultDateTimeFormat, plot, plotLoading, plotSaving, plotEventsLoading } = this.props;

        const plotName = plot ? plot.name : 'Unknown Site';

        return (<><ContentTabs
            labelLoading={"loading site"}
            label404={"Could not find site."}
            loading={this.props.plotLoading || this.props.plotSaving}
            tabs={[
                {
                    dataReady: plot !== undefined,
                    label: "Info",
                    labelIcon: "fa-info",
                    component: <PlotAdminEdit
                        dateTimeFormat={defaultDateTimeFormat}
                        plot={plot}
                        saving={plotSaving}
                    />,
                    title: plotName
                },
                {
                    dataReady: plot !== undefined && plot.plotEvents !== undefined,
                    label: "Scans",
                    labelIcon: "fa-eye",
                    component: <PlotEventAdminSearch
                        dateTimeFormat={defaultDateTimeFormat}
                        getPlotEvents={this.props.getPlotEvents}
                        maxPlotEvents={500}
                        onEndDateChange={this.onPlotEventSearchEndDateChange.bind(this)}
                        onStartDateChange={this.onPlotEventSearchStartDateChange.bind(this)}
                        plotEvents={plot ? plot.plotEvents : undefined}
                        plotEventsLoading={plotEventsLoading}
                        searchStartDate={this.state.plotEventSearchStartDate}
                        searchEndDate={this.state.plotEventSearchEndDate}
                        totalPlotEventCount={plot ? plot.totalPlotEventCount : undefined}
                    />,
                    title: plotName
                },
                {
                    dataReady: plot !== undefined,
                    label: "Monitoring",
                    labelIcon: "fa-user",
                    component: <div className="col-12"><PaginatedTable
                        countPerPage={25}
                        data={this.props.userRoles}
                        dataColumns={[
                            {
                                label: "ID",
                                dataKey: undefined,
                                render: (ur: DTOS.UserRole) => <Link to={`/admin/user/${ur.user.id}`}>{ur.user.id}</Link>
                            },
                            {
                                label: "Surname",
                                dataKey: undefined,
                                render: (ur: DTOS.UserRole) => <Link to={`/admin/user/${ur.user.id}`}>{ur.user.surname}</Link>
                            },
                            {
                                label: "Role",
                                dataKey: undefined,
                                render: (ur: DTOS.UserRole) => <span>{ur.role.name}</span>
                            },
                            {
                                label: "Import Data",
                                dataKey: undefined,
                                render: (ur: DTOS.UserRole) => ur.user && ur.plot ? <Link className="btn btn-info" to={`${ur.plot.id}/import?userId=${ur.user.id}`}>
                                    <i className="fa fa-upload p-1" />Import
                            </Link> : <span>N/A</span>
                            },
                            {
                                label: "Remove",
                                dataKey: undefined,
                                render: (ur: DTOS.UserRole) => ur.user && ur.plot ? <span className="btn btn-danger" onClick={() => this.onDeleteUserRole(ur)}>
                                    <i className="fa fa-ban p-1" />Remove
                            </span> : <span>N/A</span>
                            }
                        ]}
                        dataLoading={this.props.userRolesLoading}
                        dataSortOptions={undefined}
                        sort={undefined}
                        tableClassName={"table-sm table-bordered table-hover"}
                    /></div>,
                    title: plotName
                },
                {
                    dataReady: this.props.plot !== undefined,
                    label: "Site Page",
                    labelIcon: "fa-arrow-right",
                    component: <Redirect push to={`/site/${this.props.plot ? this.props.plot.id : -1}`} />
                }
            ]}
        />
            <ModalMessage
                onRequestClose={this.onDeleteUserRoleHideModal}
                onNegativeResponse={this.onDeleteUserRoleHideModal}
                onPositiveResponse={this.onDeleteUserRoleItem}
                isOpen={this.state.showDeleteUserRoleModal}
                label="Discontinue User Monitoring Site"
                message={`Are you sure you want to remove ${this.state.deleteUserRole
                    ? this.state.deleteUserRole.user.fullName + ' (User Id: ' + this.state.deleteUserRole.user.id + ')'
                    : 'UNKNOWN USER'} from monitoring this site?`}

                positiveResponseLabel="Remove"
                positiveResponseClass="btn-danger"
                negativeResponseLabel="Cancel"
                negativeResponseClass="btn-secondary"
            />
        </>);
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageAdminPlotEditAllProps): PageAdminPlotEditPropsMapped => {

    const plot = state.data.plots ? state.data.plots.find(p => p.id === Number(ownProps.routeParams.plotId)) : undefined;

    return {
        plot: plot,
        plotLoading: state.data.plotLoading,
        plotEventsLoading: state.data.plotEventsLoading,
        plotPhotoUploading: state.data.plotPhotoUploading,
        plotSaving: state.data.plotSaving,
        referenceData: state.referenceData,
        userRoles: state.admin.userRoles,
        userRolesLoading: state.admin.userRolesLoading,
        userRoleUnassignPending: state.user.userRoleUnassignPending
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageAdminPlotEditActionsMapped>({
        getPlotEvents: DataActionCreators.getPlotEventsRequest,
        getSinglePlot: DataActionCreators.getSinglePlotRequest,
        searchUserRoles: AdminActionCreators.searchUserRolesRequest,
        unassignUserRole: UserActionCreators.unassignUserRoleRequest,
        updatePlot: DashboardActionCreators.updatePlotRequest,
        uploadPlotPhotos: DashboardActionCreators.uploadPlotPhotosRequest,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageAdminPlotEdit);